import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import './FarmerMap.css'

// Static map image of Pakistan
import { IMAGES } from '../../constants/constants';// Ensure you have the correct path to your static image

// Sample farmer locations in Pakistan
const farmerLocations = [
  { id: 1, name: 'Karachi', coordinates: [67.0011, 24.8607] },
  { id: 2, name: 'Islamabad', coordinates: [73.0479, 33.6844] },
  { id: 3, name: 'Multan', coordinates: [71.5249, 30.1575] },
  { id: 4, name: 'Quetta', coordinates: [66.9750, 30.1941] },
  { id: 5, name: 'Lahore', coordinates: [74.3587, 31.5204] },
  { id: 6, name: 'Swat', coordinates: [72.3616, 35.2220] },
];

const FarmerMap = () => {
  return (
    <div
      
    >
      <h3>
        Farmers by Location
      </h3>
      <div style={{ position: 'relative' }}>
        <img
          src={IMAGES.pakistanMap} // Static map image
          alt="Map of Pakistan"
          style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
        />
        {/* Render farmer location markers on top of the image */}
        {/* {farmerLocations.map(({ id, name, coordinates }) => (
          <div
            key={id}
            style={{
              position: 'absolute',
              left: `${(coordinates[0] - 60) * 1.3}%`, // Adjust these values based on your map's scale
              top: `${(coordinates[1] - 20) * 1.3}%`,
              color: '#FFC107',
              fontSize: '24px',
            }}
            title={name}
          >
            <FaMapMarkerAlt />
          </div>
        ))} */}
      </div>
    </div>
  );
};

export default FarmerMap;
